import { makeAutoObservable, runInAction, action } from 'mobx'
import { GcApi } from '@api/index'

class GiftCardStore {
  constructor () {
    makeAutoObservable(this, {}, { autoBind: true })
  }
  decorationIsInit: boolean = false
  eGiftCardList: IEGiftCardInfo[] = []
  giftCardList: IEGiftCardInfo[] = []
  decorationInfo: IDecorationInfo = {}
  hasGiveCard: boolean = false
  // 获取电子礼品卡列表
  async getEGiftCardList () {
    let res: IEGiftCardInfo[]
    try {
      res = await GcApi.getCardList()
    } catch (error) { }
    runInAction(() => {
      res && (this.giftCardList = res)
      res && (this.eGiftCardList = res.filter((item: any) => item.status === 'enable' && ['mix', 'electronic'].includes(item.type)).reverse())
    })
    return res
  }
  // 获取电子礼品卡装修数据
  async getEGiftCardDecoration () {
    if (this.decorationIsInit) return
    let res: any
    try {
      this.decorationIsInit = true
      res = await GcApi.getCardDecoration()
    } catch (error) { }
    runInAction(() => {
      if (res?.content) {
        this.decorationInfo = JSON.parse(res.content)
      } else {
        this.decorationInfo = {
          purchaseDecorates: {
            basicInfo: {
              showCardName: 1,
              showCardAmount: 1
            }
          }
        }
      }
    })
    return res
  }

  // 通过接口获取是否存在转赠未绑定礼品卡
  async getGiveCardFlag (memberId?: number) {
    try {
      const flag = await GcApi.getGiveFlag(memberId)
      this.hasGiveCard = flag
    } catch (error) { }
  }
  // 获取电子礼品卡详情
  async getEGiftCard (cardId: number) {
    let res: IEGiftCardInfo
    try {
      res = await GcApi.getCardDetail(cardId)
    } catch (error) { }
    return res
  }
}

export default new GiftCardStore()
